import React, { Component } from "react";
class TimePicker extends Component {
  state = { hour: 12, min: "00", ampm: "AM" };
  componentWillMount() {
    this.setState({
      ...this.state,
      hour: this.props.currentTime.split(":")[0],
      min: this.props.currentTime.split(":")[1].split(" ")[0],
      ampm: this.props.currentTime.split(":")[1].split(" ")[1]
    });
  }
  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          margin: "10px 0px",
        }}
        onBlur={() => {
          this.props.changeTime(
            this.props.day,
            this.props.type,
            `${this.state.hour.toString().length < 2 ? "0" : ""}${
            this.state.hour
            }:${this.state.min.toString().length < 2 ? "0" : ""}${
            this.state.min
            } ${this.state.ampm}`
          );
        }}
      >
        <input
          type="number"
          min={1}
          max={12}
          style={{ backgroundColor: 'transparent', padding: "0px" }}
          value={this.state.hour}
          onChange={e => {
            if (
              (e.target.value >= 1 && e.target.value <= 12) ||
              e.target.value === ""
            ) {
              this.setState({
                ...this.state,
                hour: e.target.value === "" ? "-" : parseInt(e.target.value, 10)
              });
            }
          }}
        />
        <div style={{marginLeft: 10, marginRight: 10}}>:</div>
        <input
          type="number"
          min={0}
          max={59}
          style={{ backgroundColor: 'transparent', padding: "0px"}}
          value={this.state.min}
          onChange={e => {
            if (
              (e.target.value >= 0 && e.target.value <= 59) ||
              e.target.value === ""
            ) {
              this.setState({
                ...this.state,
                min: e.target.value === "" ? "-" : parseInt(e.target.value, 10)
              });
            }
          }}
        />
        <div style={{marginLeft: 10, marginRight: 10}}>:</div>
        <input
          type="text"
          value={this.state.ampm && this.state.ampm != "undefined" ? this.state.ampm : ""}
          style={{ backgroundColor: 'transparent', width: "30px", padding: "0px" }}
          onKeyPress={event => {
            if (event.key === "A" || event.key === "a") {
              this.setState({
                ...this.state,
                ampm: "AM"
              });
            } else if (event.key === "P" || event.key === "p") {
              this.setState({
                ...this.state,
                ampm: "PM"
              });
            } else if (this.state.ampm === null) {
              this.setState({
                ...this.state,
                ampm: "AM"
              });
            }
          }}
        />
      </div>
    );
  }
}

export default TimePicker;
